module.exports = __webpack_public_path__ + "media/images/logo-3b418f7e43c2b012d839917eb107c534.png";